import { Skeleton } from "./skeleton";

export function JobCardSkeleton() {
  return (
    <div className="w-full rounded-[8px] border border-black bg-white p-[12px] flex flex-col gap-[12px]">
      <div className="flex items-start gap-2">
        <Skeleton className="h-[42px] w-[42px] rounded-lg shrink-0" />
        <div className="flex flex-1 flex-col gap-[6px]">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-3 w-2/3" />
        </div>
      </div>

      <div className="flex flex-wrap gap-[12px]">
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={`meta-${index}`} className="flex items-center gap-[6px]">
            <Skeleton className="h-5 w-5 rounded-full" />
            <Skeleton className="h-4 w-16" />
          </div>
        ))}
      </div>

      <div className="flex flex-wrap gap-[6px]">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={`skill-${index}`} className="h-5 w-16 rounded-[4px]" />
        ))}
      </div>
    </div>
  );
}

export function JobCardSkeletonList({ count = 3 }: { count?: number }) {
  return (
    <div className="flex w-full flex-col gap-2">
      {Array.from({ length: count }).map((_, i) => (
        <JobCardSkeleton key={i} />
      ))}
    </div>
  );
}
